import { GET } from "../../../module/services/fetch";
import { map } from "rxjs/operators";

export const fetchUserEntitlementService = () =>
  GET("user/entitlements").pipe(map((response: any) => response));
